import React, { FC } from 'react';
import * as S from '../../styled';
import { GENDER_VALUES } from '../../../../constants';

interface Props {
	gender: string;
	onChangeGender: (e: any) => void;
}

export const GenderButtons: FC<Props> = props => {
	const { gender, onChangeGender } = props;

	return (
		<S.FormRadioGroup>
			<S.FormRadioGroupItem>
				<input
					id={GENDER_VALUES.FEMALE}
					type='radio'
					name='gender'
					value={GENDER_VALUES.FEMALE}
					checked={gender === GENDER_VALUES.FEMALE}
					onChange={e => onChangeGender(e)}
				/>
				<label htmlFor={GENDER_VALUES.FEMALE}>Female</label>
			</S.FormRadioGroupItem>
			<S.FormRadioGroupItem>
				<input
					id={GENDER_VALUES.MALE}
					type='radio'
					name='gender'
					value={GENDER_VALUES.MALE}
					checked={gender === GENDER_VALUES.MALE}
					onChange={e => onChangeGender(e)}
				/>
				<label htmlFor={GENDER_VALUES.MALE}>Male</label>
			</S.FormRadioGroupItem>
		</S.FormRadioGroup>
	);
};
